<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :show_description_dialog_btn="false"
                :show_download_doc_btn="show_download_doc_btn"
                :show_download_pdf_btn="show_download_pdf_btn"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

	export default {
        name: 'child_none_feature',
        
        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable,
        },
        
        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                required: true,
            },

            show_download_doc_btn: {
                type: Boolean,
                default() {
                    return false
                }
            },
            in_overview_page: {
                type: Boolean,
                default() {
                    return false;
                }
            },
        },

        data() {
            return {
                table_data: [],
                header: [],
                error_text: '',
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            show_download_pdf_btn() {
                return !this.in_overview_page
            },
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value);
        },

		methods: {
            generate_table_data(data, header) {
                this.table_data = data;
                this.header = header;
            },
        },
	}
</script>